/**
 * Збій оболонки (виняток у кореневому компоненті): без роутера й запитів, лише перезавантаження
 * і звернення. Чернетки форм у `sessionStorage` перезавантаження переживають (UX-26).
 *
 * Лежить у головному чанку й малий: це запасний екран для всіх лінивих станів помилок
 * (`ErrorState.tsx`), якщо їхній чанк не доїхав (обрив, стара вкладка після релізу).
 */
import { usePageTitle } from '../brand/env.ts';
import { common as c } from '../i18n/uk/common.ts';
import { supportCore as t } from '../i18n/uk/support-core.ts';
import { StateView } from '../ui/StateView.tsx';
import { traceIdOf } from './classify.ts';

/** Код збою інтерфейсу (виняток під час показу): помилки коду немає, є лише слід у журналі клієнта. */
export const UI_CRASH_CODE = 'UI-500';

/**
 * Збій оболонки (виняток у кореневому компоненті): без роутера й запитів, лише перезавантаження
 * і звернення. Чернетки форм у `sessionStorage` перезавантаження переживають (UX-26).
 */
export function RootError({ error, embedded = false }: { error: unknown; embedded?: boolean }) {
  usePageTitle(c.errorTitle);
  const view = (
    <StateView
      icon="alert-circle"
      tone="error"
      title={t.rootTitle}
      text={t.rootText}
      code={UI_CRASH_CODE}
      traceId={traceIdOf(error)}
      page
    >
      <button className="btn btn--primary" type="button" onClick={() => window.location.reload()}>
        {t.reload}
      </button>
      <a className="btn" href="/">
        {t.toHome}
      </a>
    </StateView>
  );
  // Запасний екран лінивого стану всередині оболонки: свого `<main>` не додає (він уже є).
  return embedded ? view : <main className="state-root">{view}</main>;
}
